import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';

type Props = {
  open: boolean;
  apiKey: string;
  title?: string;
  onClose: () => void;
};

const BuildApiKeyRevealDialog = ({
  open,
  apiKey,
  title = 'API kulcs — másold el most',
  onClose,
}: Props) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      enqueueSnackbar('Kulcs a vágólapra másolva.', { variant: 'success' });
    } catch {
      enqueueSnackbar('Másolás sikertelen — jelöld ki kézzel.', {
        variant: 'warning',
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          A teljes kulcs csak most látható. Bezárás után nem kérdezhető le újra —
          ha elveszik, generálj újat (rotálás), és frissítsd az ADO{' '}
          <code>RELEASE_PROFILE_API_KEY</code> secretet.
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={2}
          value={apiKey}
          slotProps={{ input: { readOnly: true } }}
          label="Build API kulcs"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCopy} color="primary" variant="outlined">
          Másolás
        </Button>
        <Button onClick={onClose} color="primary" variant="contained">
          Bezárás
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BuildApiKeyRevealDialog;
